module.exports = __webpack_public_path__ + "img/bg1.819e2e3f.jpg";